import { Col, Row } from "reactstrap";
import PageImage from "../../CommonComponents/PageImage";
import LeaveComment from "../RightSidebar/BlogDetails/LeaveComment";
import Comments from "./Comments";
import Details from "./Details";

const SidebarDetailsContainer = () => {
  return (
    <section className="blog-detail-page section-py-space blog-page">
      <PageImage/>
      <div className="custom-container">
        <Row>
          <Col xl="12">
            <Row>
              <Details />
              <Comments />
              <LeaveComment blogClass="blog-card"/>
            </Row>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default SidebarDetailsContainer;
